import React from "react";
import { Div } from "components/Base";
import { connect } from "react-redux";
import { SESSION_MODAL_TABS_INSTANCE_ID } from "EventLight/Sessions/AddSessionModal/constants";
import Tabs from "ui-kit/Tabs/View";
import { getTabsList, getDefaultTab } from "../selectors";

const decorate = connect(
  state => ({
    tabList: getTabsList(state),
    defaultTab: getDefaultTab(state)
  }),
  {}
);

const Header = ({ tabList, defaultTab }) => (
  <Div
    bg="neutral0"
    width={1}
    bb={1}
    bc="neutral2"
    display="column.space-between"
    style={{
      position: "relative",
      paddingTop: 20,
      paddingBottom: 0,
      paddingLeft: 20
    }}
  >
    <Div display="row.flex-start.center">
      <Tabs
        instanceId={SESSION_MODAL_TABS_INSTANCE_ID}
        iniSelected={defaultTab}
        tabs={tabList}
        flex={1}
        tabStyle={{
          fs: 4,
          pb: 3
        }}
      />
    </Div>
  </Div>
);

export default decorate(Header);
